/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessTokenModel } from '../../models/access-token-model';
import { UserRegistrationModel } from '../../models/user-registration-model';

export interface LocalAccountRegisterUserPost$Params {
  
    /**
     * User registration model containing user details and preferences
     */
    body?: UserRegistrationModel
}

export function localAccountRegisterUserPost(http: HttpClient, rootUrl: string, params?: LocalAccountRegisterUserPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<AccessTokenModel>> {
  const rb = new RequestBuilder(rootUrl, localAccountRegisterUserPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<AccessTokenModel>;
    })
  );
}

localAccountRegisterUserPost.PATH = '/LocalAccount/RegisterUser';
